module.exports = __webpack_public_path__ + "img/card-step.6d0f1bb3.png";